// src/plugins/fake-api/handlers/auth/db.js
export const db = {
  users: [
    {
      id: 1,
      email: 'gindalbie@salubris.au',
      password: 'admin',
      fullName: 'Gindalbie Operations',
      username: 'gindalbie',
      role: 'admin',
      avatar: null,
      status: 'active',
      lastLogin: new Date().toISOString(),
      abilityRules: [
        {
          action: 'manage',
          subject: 'all',
        },
      ],
    },
    {
      id: 2,
      email: 'monitor@salubris.au',
      password: 'display',
      fullName: 'Display Monitor',
      username: 'display',
      role: 'viewer',
      avatar: null,
      status: 'active',
      lastLogin: new Date().toISOString(),
      abilityRules: [
        {
          action: 'read',
          subject: 'dashboard',
        },
      ],
    },
    {
      id: 3,
      email: 'client@salubris.au',
      password: 'client',
      fullName: 'Traditional Owner Partner',
      username: 'client',
      role: 'client',
      avatar: null,
      status: 'active',
      lastLogin: new Date().toISOString(),
      abilityRules: [
        {
          action: 'read',
          subject: 'dashboard',
        },
        {
          action: 'read',
          subject: 'assets',
        },
        {
          action: 'read',
          subject: 'data',
        },
      ],
    },
  ],
  userTokens: {
    1: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiZW1haWwiOiJnaW5kYWxiaWVAc2FsdWJyaXMuYXUiLCJyb2xlIjoiYWRtaW4ifQ',
    2: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MiwiZW1haWwiOiJtb25pdG9yQHNhbHVicmlzLmF1Iiwicm9sZSI6InZpZXdlciJ9',
    3: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MywiZW1haWwiOiJjbGllbnRAc2FsdWJyaXMuYXUiLCJyb2xlIjoiY2xpZW50In0',
  },
}
